// extracted by mini-css-extract-plugin
module.exports = {"all_center":"j5vPusWa","comp-wrapper":"Y8Hf2bW_","nav":"KYFEeNeD","layout-footer":"efEDe_ya","infiniteRotating":"_bST023E","fadeInOpacity":"kDqcQAsu"};